export const returnLeftPosition = (category, position) => {
  switch (category?.toLowerCase()) {
    case "Οικονομία - Επιχειρηματικότητα".toLowerCase():
      return position === "Right"
        ? "190px"
        : position === "Middle"
        ? "-50px"
        : position === "Left"
        ? "-250px"
        : ""
    case "Θεσμική Παρουσία".toLowerCase():
      return position === "Right"
        ? "75px"
        : position === "Middle"
        ? "-115px"
        : position === "Left"
        ? "-350px"
        : ""
    case "Κατάρτιση & δεξιότητες".toLowerCase():
      return position === "Right"
        ? "100px"
        : position === "Middle"
        ? "-125px"
        : position === "Left"
        ? "-350px"
        : ""
    case "Κοινωνική πολιτική".toLowerCase():
      return position === "Right"
        ? "100px"
        : position === "Middle"
        ? "-160px"
        : position === "Left"
        ? "-415px"
        : ""
    case "Εργασία".toLowerCase():
      return position === "Right"
        ? "100px"
        : position === "Middle"
        ? "-125px"
        : position === "Left"
        ? "-350px"
        : ""

    default:
      return ""
  }
}

export const returnTopPosition = (category, position) => {
  switch (category) {
    case "Οικονομία - Επιχειρηματικότητα":
      return position === "Right"
        ? "-135px"
        : position === "Middle"
        ? "-130px"
        : position === "Left"
        ? "-70px"
        : ""
    case "Θεσμική Παρουσία":
      return position === "Right"
        ? "-40px"
        : position === "Middle"
        ? "-25px"
        : position === "Left"
        ? "-360px"
        : ""
    case "Κατάρτιση & δεξιότητες":
      return position === "Right"
        ? "-155px"
        : position === "Middle"
        ? "-140px"
        : position === "Left"
        ? "-250px"
        : ""
    case "Κοινωνική πολιτική":
      return position === "Right"
        ? "-50px"
        : position === "Middle"
        ? "-10px"
        : position === "Left"
        ? "-120px"
        : ""
    case "Εργασία":
      return position === "Right"
        ? "20px"
        : position === "Middle"
        ? "-150px"
        : position === "Left"
        ? "-70px"
        : ""
    default:
      return ""
  }
}
